/**
 * Cart drawer upsell — quick "add to cart" for the product referenced by
 * a cart item's custom.cart_upsell metafield.
 *
 * Upload this file to your theme's Assets folder as: cart-upsell.js
 */
(function () {
  if (window.__cartUpsellInit) return;
  window.__cartUpsellInit = true;

  function setLabel(button, text) {
    var label = button.querySelector('[data-cart-upsell-label]');
    if (label) label.textContent = text;
  }

  function refreshCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        document.querySelectorAll('cart-count').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      })
      .catch(function () {
        /* non-fatal: count badge just won't refresh */
      });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-cart-upsell-add]');
    if (!button || button.disabled) return;

    var variantId = button.getAttribute('data-variant-id');
    var sectionId = button.getAttribute('data-section-id');
    if (!variantId || !sectionId) return;

    var labelEl = button.querySelector('[data-cart-upsell-label]');
    var originalLabel = labelEl ? labelEl.textContent : 'Add to cart';

    button.disabled = true;
    setLabel(button, 'Adding...');

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: sectionId,
        sections_url: window.location.pathname
      })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) {
            throw new Error((data && data.description) || 'Unable to add item to cart');
          }
          return data;
        });
      })
      .then(function (data) {
        var sectionHtml = data.sections && data.sections[sectionId];
        if (!sectionHtml) {
          window.location.reload();
          return;
        }

        var doc = new DOMParser().parseFromString(sectionHtml, 'text/html');

        // Refresh the line-item list so the newly added product appears.
        var newItems = doc.querySelector('cart-items');
        var currentItems = document.querySelector('cart-items');
        if (newItems && currentItems) {
          currentItems.innerHTML = newItems.innerHTML;
        }

        // Refresh the subtotal.
        var newSubtotal = doc.getElementById('CartSubtotal-' + sectionId);
        var currentSubtotal = document.getElementById('CartSubtotal-' + sectionId);
        if (newSubtotal && currentSubtotal) {
          currentSubtotal.textContent = newSubtotal.textContent;
        }

        // Refresh (or remove) the upsell card itself — e.g. hide it once
        // its product is already in the cart, or swap to the next candidate.
        var newUpsell = doc.getElementById('CartUpsell-' + sectionId);
        var currentUpsell = document.getElementById('CartUpsell-' + sectionId);
        if (currentUpsell) {
          if (newUpsell) {
            currentUpsell.replaceWith(newUpsell);
          } else {
            currentUpsell.remove();
          }
        }

        refreshCartCount();
      })
      .catch(function (error) {
        setLabel(button, originalLabel);
        button.disabled = false;
        console.error('Cart upsell add error:', error);
      });
  });
})();